export default __webpack_public_path__ + "img/gfx_apac_insights-78567f66771760ccdf445e5dc5d6ed84.png";